import { observable } from 'mobx';
import type { SettingArgs, SettingResponseArgs } from '../setting2';
import { convertSettingResponseToArgs } from '../setting2';

export const RevenueReferenceDateTypes: { [key: string]: string } = {
  confirmed_at: '予約確定日',
  end_date: '出張完了日'
};

export type WorkflowStyle = 'department' | 'trip';

export type ForbiddenRepositoryArgs = {
  category: string;
  repository: string;
};

export type OrganizationResponseArgs = {
  id: number;
  name: string;
  url?: string;
  address?: string;
  tel?: string;
  revenue_reference_date_type?: number;
  setting?: SettingResponseArgs;
  freee_workflow?: boolean;
  exic_usage_mode?: string;
  allow_user_exic_input?: boolean;
  show_ex?: boolean;
  show_fee?: boolean;
  workflow_style?: WorkflowStyle;
  concur_client_id: string;
  concur_client_secret?: string;
  forbidden_repositories?: ForbiddenRepositoryArgs[]; // 右ナビのSMAS利用の表示に使う
};

export type OrganizationArgs = {
  id?: number;
  name?: string;
  url?: string;
  address?: string;
  tel?: string;
  revenueReferenceDateType?: number;
  setting?: SettingArgs;
  freeeWorkflow?: boolean;
  exicUsageMode?: string;
  allowUserExicInput?: boolean;
  showEx?: boolean;
  workflowStyle?: WorkflowStyle;
  concurClientId: string;
  concurClientSecret?: string;
  forbiddenRepositories?: ForbiddenRepositoryArgs[]; // 右ナビのSMAS利用の表示に使う
};

export const convertOrganizationResponseToArgs = (response: OrganizationResponseArgs) => {
  const args: OrganizationArgs = {
    id: response.id,
    name: response.name,
    url: response.url,
    address: response.address,
    tel: response.tel,
    revenueReferenceDateType: response.revenue_reference_date_type,
    setting: response.setting ? convertSettingResponseToArgs(response.setting) : undefined,
    freeeWorkflow: response.freee_workflow,
    exicUsageMode: response.exic_usage_mode,
    allowUserExicInput: response.allow_user_exic_input,
    showEx: response.show_ex,
    workflowStyle: response.workflow_style,
    concurClientId: response.concur_client_id,
    concurClientSecret: response.concur_client_secret,
    forbiddenRepositories: response.forbidden_repositories
  };
  return args;
};

export default class Organization {
  @observable id?: number;
  @observable name?: string;
  @observable url?: string;
  @observable address?: string;
  @observable tel?: string;
  @observable revenueReferenceDateType?: number;
  @observable setting?: SettingArgs;
  @observable freeeWorkflow?: boolean;
  @observable exicUsageMode?: string;
  @observable allowUserExicInput?: boolean;
  @observable showEx?: boolean;
  @observable workflowStyle?: WorkflowStyle;
  @observable concurClientId: string | null | undefined;
  @observable concurClientSecret: string | null | undefined;
  @observable forbiddenRepositories?: ForbiddenRepositoryArgs[];

  constructor(args: OrganizationArgs) {
    this.id = args.id;
    this.name = args.name;
    this.url = args.url;
    this.address = args.address;
    this.tel = args.tel;
    this.revenueReferenceDateType = args.revenueReferenceDateType;
    this.setting = args.setting;
    this.freeeWorkflow = args.freeeWorkflow;
    this.exicUsageMode = args.exicUsageMode;
    this.allowUserExicInput = args.allowUserExicInput;
    this.showEx = args.showEx;
    this.workflowStyle = args.workflowStyle;
    this.concurClientId = args.concurClientId;
    this.concurClientSecret = args.concurClientSecret;
    this.forbiddenRepositories = args.forbiddenRepositories;
  }
}
